<template>
  <div class="container w-100" id="parent-report-page">
    <div class="row" id="page-parent-report">
      <div class="col-md-12 p-0 m-0">
        <div class="row">
          <div v-if="typeShowChart=='year'" class="col-md-6 text-right pt-3">
            <span class="next-previous-text btn-next-previous float-right pr-3" @click="previousYear" >&lt; 前年</span>
            <span class="float-right text-right year-month-text year-chart">{{current_year}}年</span>
            <span v-if="current_year < new Date().getFullYear()" class="next-previous-text btn-next-previous float-right pl-3" @click="nextYear">来年 &gt;</span>
          </div>
          <div v-if="typeShowChart=='month'" class="col-md-6 text-right pt-3">
            <span class="next-previous-text btn-next-previous float-right pr-3" @click="previousMonth">&lt; 前月</span>
            <span class="float-right text-right year-chart year-month-text">{{current_year}}年</span>
            <span class="month-chart year-month-text">{{current_month}}月</span>
            <span v-if="current_year < new Date().getFullYear() ||current_year == new Date().getFullYear() && current_month <new Date().getMonth()+1 " class="next-previous-text btn-next-previous float-right pl-3" @click="nextMonth">次月 &gt;</span>
          </div>
          <div class="col-md-6 border-0 btn-header">
            <el-select
              v-model="typeShowChart"
              class="btn-select-time-show-sale-chart"
              @change="changeType"
            >
              <el-option
                v-for="item in optionsTime"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>

            <el-select
              class="btn-select-branch-store-child"
              @change="changeStoreBranch"
              v-model="current_clinic_child.id" filterable>
              <el-option
                v-for="item in storeBranchs"
                :key="item.id"
                :label="item.clinic_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-if="typeShowChart=='year'" class="row mt-3" id="sale-chart">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="p-2">
                  <div class="row">
                    <div class="col-md-12 p-0">
                      <div v-if="Object.values(treatment_day_of_months).some(e=>e>0)">
                        <SaleChart />
                      </div>
                      <div v-else>
                        <p class="text-center">データなし</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="card-title">メニュー別割合</h5>
            <div class="card">
              <div class="card-body">
                <div class="p-2">
                  <div class="row">
                    <div class="col-xs-12 col-md-12 p-0">
                      <div v-if="time_prices_chart.length>0">
                        <TimepriceChart />
                      </div>
                      <div v-else>
                        <p class="text-center">データなし</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h5 class="card-title">年齢別割合</h5>
            <div class="card">
              <div class="card-body">
                <div class="p-2">
                  <div class="row">
                    <div class="col-xs-12 col-md-12 p-0">
                      <div v-if="age_customers_chart.map(e => Object.values(e)).flat().some(o => o>0)">
                        <AgeChart />
                      </div>
                      <div v-else>
                        <p class="text-center">データなし</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        scale age chart-->
        <div class="row">
          <div class="col-md-12">
            <h5 class="card-title">性別割合</h5>
            <div class="card">
              <div class="card-body">
                <div class="p-2">
                  <div class="row">
                    <div class="col-md-12 p-0">
                      <div v-if="scale_gender_chart.map(e => Object.values(e)).flat().some(o => o> 0)">
                        <GenderChart />
                      </div>
                      <div v-else>
                        <p class="text-center">データなし</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        revanue therapist chart-->
        <div class="row">
          <div class="col-md-12">
            <h5 class="card-title">サービス提供者別売上</h5>
            <div class="card">
              <div class="card-body">
                <div class="p-2">
                  <div class="row">
                    <div class="col-md-12 p-0">
                      <div v-if="Object.values(therapists_chart).some(e=>e>0)">
                        <TherapistChart />
                      </div>
                      <div v-else>
                        <p class="text-center">データなし</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        average therapist chart-->
        <div class="row">
          <div class="col-md-12">
            <h5 class="card-title">サービス提供者の平均単価</h5>
            <div class="card">
              <div class="card-body">
                <div class="p-2">
                  <div class="row">
                    <div class="col-md-12 p-0">
                      <div v-if="Object.values(therapists_average_revanue).some(e=>e>0)">
                        <AverageRevanueTherapist />
                      </div>
                      <div v-else>
                        <p class="text-center">データなし</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters} from 'vuex'
  import SaleChart from "./SaleChart";
  import TimepriceChart from "./TimepriceChart";
  import AgeChart from "./AgeChart";
  import TherapistChart from "./TherapistChart";
  import AverageRevanueTherapist from "./AverageRevenueTherapist"
  import GenderChart from "./GenderChart"
  export default {
    name: "index",
    data() {
      return {
        optionsTime: [{
          value: 'year',
          label: '年'
        }, {
          value: 'month',
          label: '月'
        }],
        typeShowChart: 'year',
        current_year: new Date().getFullYear(),
        current_month: new Date().getMonth()+1,
      }
    },
    components: {
      SaleChart, TimepriceChart, AgeChart, TherapistChart, AverageRevanueTherapist, GenderChart
    },
    computed: {
      ...mapGetters(['storeBranchs', 'current_clinic_child', 'time_prices_chart', 'treatment_day_of_months', 'age_customers_chart', 'therapists_chart', 'therapists_average_revanue', 'scale_gender_chart']),
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      ...mapActions('parent_report', ['fetchDataParentReportChart']),
      changeStoreBranch() {
        this.fetchData()
      },
      fetchData(){
        this.fetchDataParentReportChart({type: this.typeShowChart, year: this.current_year, month: this.current_month, clinic_id: this.current_clinic_child.id})
      },
      changeType() {
        this.fetchDataParentReportChart({type: this.typeShowChart, year: this.current_year, month: this.current_month, clinic_id: this.current_clinic_child.id})
      },
      previousYear() {
        this.current_year -= 1
        this.fetchData()
      },
      nextYear() {
        this.current_year += 1
        this.fetchData()
      },
      previousMonth() {
        this.current_month -= 1
        if (this.current_month < 1) {
          this.current_year -=1
          this.current_month = 12
        }
        this.fetchData()
      },
      nextMonth() {
        this.current_month += 1
        if (this.current_month > 12) {
          this.current_year +=1
          this.current_month = 1
        }
        this.fetchData()
      }
    }
  }
</script>

<style lang="scss">
  #parent-report-page{
    .btn-header {
      text-align: right;
    }
    .btn-select-branch-store-child>.el-input--suffix .el-input__inner {
      width: 230px;
      border: none;
      border-radius: 7px;
    }
    .btn-select-time-show-sale-chart>.el-input--suffix .el-input__inner {
      width: 65px;
      border: none;
      border-radius: 7px;
    }
    .year-month-text{
      font-size: 22px;
    }
  }
</style>
